module.exports = __webpack_public_path__ + "static/media/bgMancha_404.e40ab865.svg";